module.exports = __webpack_public_path__ + "img/ic_facebook.2e32efe3.svg";